import React from 'react';
export default function renderWithLineBreaks(text) {
    if (!text) return null;

    // Split the text into an array of lines
    const lines = text.split('\n');

    // Map over the lines, rendering the text and a <br /> after each line (except the last)
    return lines.map((line, index) => (
        // Use React.Fragment or a div to wrap the line and the <br />
        <React.Fragment key={index}>
            {line}
            {/* Conditional <br />: only add if it's not the last line */}
            {index < lines.length - 1 && <br />}
        </React.Fragment>
    ));
};